import React from 'react';
import { useTranslation } from 'react-i18next';

import { ToggleField } from '@mssgme/ui';
import { FieldTip } from '@mssgme/app/components/UI';
import CardEditForm from '../CardEditForm';

export default function BrandingEdit() {
    const { t } = useTranslation('cards');

    return (
        <CardEditForm title={t('BrandingEdit.title')} backPath="/p/settings" successRedirectPath="/p/settings">
            <ToggleField name="design.branding" label={t('BrandingEdit.labels.enabled')} restrictRule="brand:edit" />
            <FieldTip>{t('FieldTip.branding')}</FieldTip>
        </CardEditForm>
    );
}
